/**
 * useSalesMetrics Hook
 *
 * React Query hook for product sales metrics.
 */

import { useQuery } from '@tanstack/react-query';
import { getProductSalesMetrics } from '@/lib/api/products';

/**
 * Get sales metrics for a product.
 */
export function useSalesMetrics(productId: string) {
  return useQuery({
    queryKey: ['sales-metrics', productId],
    queryFn: () => getProductSalesMetrics(productId),
    enabled: !!productId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
